<template>
  <div id="equipmentPopup" @click.stop="closePopup">
    <div class="chartBox" @click.stop>
      <el-image
        class="chartBorderImg"
        fit="fill"
        :src="chartData.bgImg"
      ></el-image>
      <div class="chartTitleBox">
        <div class="titleCls">
          <span>{{ chartData.houseStructureDetail }}</span>
          <span>{{ chartData.name }}</span>
        </div>
        <div class="runStatus" :style="runStatusColor(chartData.statusCode)">
          {{ chartData.runStatus }}
        </div>
      </div>
      <div class="chart">
        <smart-equipment-chart :equipmentData.sync="chartData"></smart-equipment-chart>
      </div>
    </div>
  </div>
</template>
<script>
import SmartEquipmentChart from "@/components/subComponents/smartEquipmentChart.vue";
export default {
  name: "equipmentPopup",
  components: {
    SmartEquipmentChart,
  },
  data() {
    return {};
  },
  props: {
    chartData: null,
  },
  mounted() {},
  methods: {
    closePopup() {
      this.$emit("closeEquipmentPopup");
    },
    runStatusColor(statusCode) {
      if (statusCode == 3) {
        return "color: #FF4B82";
      }
      return "color: #4BCEFF";
    },
  },
};
</script>
<style scoped>
#equipmentPopup {
  background-color: rgba(2, 5, 9, 0.85);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
}
.chartBox {
  width: 50%;
  height: 50%;
  position: relative;
}
.chartTitleBox {
  position: absolute;
  top: 10px;
  right: 16.5%;
  left: 36%;
  height: 30px;
  z-index: 3;
  text-align: left;
}
.titleCls,
.runStatus {
  display: inline-block;
  height: 28px;
  line-height: 28px;
}
.titleCls {
  width: 80%;
  font-size: 20px;
  text-align: left;
  color: #4bceff;
}
.titleCls span {
  margin-right: 10px;
  height: 60%;
}
.runStatus {
  font-size: 24px;
  width: 18%;
  text-align: center;
}
.chartBorderImg {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
.chartBorderImg {
  z-index: 1;
}
.chart {
  height: 80%;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  margin: 0 10px;
  z-index: 4;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/familyStatus/statusPages/smartSystems/equipmentChartPopup.vue